/**
 * Единая точка: URL проекта Supabase (только из env, без захардкоженных инстансов).
 */

const normalizeSupabaseUrl = (raw) => {
    if (raw == null || typeof raw !== 'string') return '';
    return raw.trim().replace(/\/$/, '');
};

export const SUPABASE_URL = normalizeSupabaseUrl(process.env.REACT_APP_SUPABASE_URL);
